import React from "react";
import { CUSTOMER_NOTIFICATION_TYPE, EMAIL_NOTIFICATION_TYPE, SMS_NOTIFICATION_TYPE } from "~/constants";
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TurnrCard, TurnrCardContent } from "~/components/card/TurnrCard.jsx";
import { faComment } from "@fortawesome/pro-regular-svg-icons";
import styles from "./CustomerNotificationModal.module.scss";
import { formatReadableDateAndTimeShort } from "rylak-common";
import { TurnrModalContainer, TurnrModalContent } from "~/components/modals/TurnrModal.jsx";

export const CUSTOMER_NOTIFICATION_MAP = {
    [CUSTOMER_NOTIFICATION_TYPE.EMAIL_NOTIFICATION]: {
        icon: faEnvelope,
        label: "Email",
        subTypes: {
            [EMAIL_NOTIFICATION_TYPE.COMPLETE_EXCHANGE]: {
                label: "Exchange payment instructions",
            },
            [EMAIL_NOTIFICATION_TYPE.COMPLAINT_REPORTED]: {
                label: "Complaint registered",
            },
            [EMAIL_NOTIFICATION_TYPE.COMPLAINT_DENIED]: {
                label: "Complaint denied",
            },
            [EMAIL_NOTIFICATION_TYPE.COMPLAINT_APPROVED]: {
                label: "Complaint approved",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_REGISTERED]: {
                label: "Return registered",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_BACK_TO_STORE]: {
                label: "Pickup booked",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_SOLD]: {
                label: "Pickup booked - C2C",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_SLIP_DELIVERY]: {
                label: "Return slip instructions",
            },
            [EMAIL_NOTIFICATION_TYPE.ABROAD_MANUAL_RETURN]: {
                label: "Manual return instructions",
            },
            [EMAIL_NOTIFICATION_TYPE.PRODUCT_IN_STOCK]: {
                label: "Product in stock",
            },
            [EMAIL_NOTIFICATION_TYPE.GIFT_CARD_CREATED]: {
                label: "Gift card created",
            },
            [EMAIL_NOTIFICATION_TYPE.PRINT_LABEL_DELIVERY]: {
                label: "Print label instructions",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_DELIVERED_TO_WAREHOUSE]: {
                label: "Items delivered to warehouse",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_COMPLETED]: {
                label: "Refund completed",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_DENIED]: {
                label: "Return denied",
            },
            [EMAIL_NOTIFICATION_TYPE.PRINT_LABEL_BOOKING_FAILED]: {
                label: "We are booking your return shipment",
            },
            [EMAIL_NOTIFICATION_TYPE.RETURN_NOT_RECEIVED]: {
                label: "Exchanged item not returned - reminder",
            },
        },
    },
    [CUSTOMER_NOTIFICATION_TYPE.SMS_NOTIFICATION]: {
        icon: faComment,
        label: "Sms",
        subTypes: {
            [SMS_NOTIFICATION_TYPE.BAGS_DELIVERED]: {
                label: "Bags delivered - C2C instructions",
            },
            [SMS_NOTIFICATION_TYPE.PICKUP_REMINDER]: {
                label: "Pickup tonight - reminder",
            },
        },
    },
};

function InfoModalSubContentComponent({ value, label }) {
    return value ? (
        <>
            <span
                className={"muted"}
                style={{
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    lineHeight: "1.0",
                }}
            >
                {label}
            </span>
            <div
                className={"muted"}
                style={{
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    lineHeight: "1.0",
                }}
            >
                {value}
            </div>
        </>
    ) : null;
}

export default function CustomerNotificationContent({ customerNotification }) {
    let entityType = customerNotification?.entityType;
    let displayData = CUSTOMER_NOTIFICATION_MAP[entityType];
    let sentEmailHtml = customerNotification?.sentHtml;
    let sentEmailSubject = customerNotification?.sentSubject;
    let fromEmail = customerNotification?.sentFromEmail;
    let toEmail = customerNotification?.sentToEmail;
    let sentSmsText = customerNotification?.sentText;
    let sentToNumber = customerNotification?.sentToNumber;

    const isEmail = !!sentEmailHtml;

    return (
        <TurnrModalContainer>
            <TurnrModalContent>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <FontAwesomeIcon style={{ marginRight: "10px" }} icon={displayData?.icon} width={"12px"} title={displayData?.label} />
                        <span
                            className={"muted"}
                            style={{
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {formatReadableDateAndTimeShort({ dateTime: customerNotification?.sentAt })}
                        </span>
                    </div>
                    <div
                        style={{
                            fontSize: "16px",
                            marginBottom: "5px",
                        }}
                    >
                        {isEmail ? sentEmailSubject : "SMS sent"}
                    </div>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "auto 1fr",
                            gridColumnGap: "10px",
                            gridRowGap: "5px",
                        }}
                    >
                        <InfoModalSubContentComponent value={fromEmail} label={"From:"} />
                        <InfoModalSubContentComponent value={toEmail} label={"To:"} />
                        <InfoModalSubContentComponent value={sentToNumber} label={"To:"} />
                    </div>
                </div>
            </TurnrModalContent>
            <TurnrModalContent>
                {isEmail ? (
                    <TurnrCard style={{ borderColor: "black", overflow: "scroll" }}>
                        <iframe className={styles["email-iframe"]} style={{ border: "none" }} srcDoc={sentEmailHtml} />
                    </TurnrCard>
                ) : (
                    <TurnrCard>
                        <TurnrCardContent>{sentSmsText}</TurnrCardContent>
                    </TurnrCard>
                )}
            </TurnrModalContent>
        </TurnrModalContainer>
    );
}
